module.exports = __webpack_public_path__ + "img/手与花装饰-3.af7e0cee.jpg";